/* Subtle Bodies — theme behaviour */
(function () {
  const body = document.body;
  const cfg = window.SB || {};
  const money = (cents) => {
    const v = (cents / 100);
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)) + ' ' + (cfg.currency || 'AUD');
  };

  /* ---------- Menu ---------- */
  document.querySelectorAll('[data-menu-toggle]').forEach((b) =>
    b.addEventListener('click', () => {
      const open = body.classList.toggle('menu-open');
      document.querySelectorAll('[data-menu-toggle]').forEach((x) => x.setAttribute('aria-expanded', open));
    })
  );
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    body.classList.remove('menu-open', 'cart-open');
    closePopup();
  });

  /* ---------- Page colour follows sections in view ---------- */
  const defaultBg = getComputedStyle(document.documentElement).getPropertyValue('--page-bg').trim() || '#ece9e5';
  const bgEls = [...document.querySelectorAll('[data-page-bg]')];
  if (bgEls.length && 'IntersectionObserver' in window) {
    const visible = new Map();
    const apply = () => {
      let pick = null, best = 0;
      visible.forEach((ratio, el) => { if (ratio > best) { best = ratio; pick = el; } });
      body.style.setProperty('--page-bg', pick && best > 0.25 ? pick.dataset.pageBg : (body.dataset.baseBg || defaultBg));
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { en.isIntersecting ? visible.set(en.target, en.intersectionRatio) : visible.delete(en.target); });
      apply();
    }, { threshold: [0, 0.25, 0.5, 0.75] });
    bgEls.forEach((el) => io.observe(el));
  }
  if (body.dataset.baseBg) body.style.setProperty('--page-bg', body.dataset.baseBg);

  /* ---------- Rail goes clear/white only alongside a full-bleed hero ---------- */
  const heroEl = document.querySelector('.sb-hero-full');
  if (heroEl) {
    const updateHero = () => {
      const r = heroEl.getBoundingClientRect();
      const on = r.top <= 48 && r.bottom > 48;
      body.classList.toggle('over-hero', on);
      body.classList.toggle('over-hero-icons', r.top <= 48 && r.bottom > 220);
      /* where the hero ends, measured down the rail (rail starts 40px from top) */
      body.style.setProperty('--hb', Math.max(0, r.bottom - 40) + 'px');
    };
    updateHero();
    window.addEventListener('scroll', updateHero, { passive: true });
    window.addEventListener('resize', updateHero);
    window.addEventListener('load', updateHero);
  }

  /* ---------- Cart ---------- */
  const drawer = document.querySelector('[data-cart-drawer]');
  const countEls = document.querySelectorAll('[data-cart-count]');

  async function getCart() { const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); return r.json(); }

  function renderCart(cart) {
    countEls.forEach((el) => (el.textContent = cart.item_count));
    if (!drawer) return;
    const bodyEl = drawer.querySelector('[data-cart-body]');
    const foot = drawer.querySelector('[data-cart-foot]');
    if (!cart.item_count) {
      bodyEl.innerHTML = '<div class="sb-drawer__empty"><p class="t-h3">Your cart is empty.</p><p style="margin-top:24px"><a class="btn" href="/collections/all">Explore the collection</a></p></div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    bodyEl.innerHTML = cart.items.map((it, i) => `
      <div class="sb-line" data-line="${i + 1}">
        <div class="sb-line__product">
          ${it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')}" alt="" loading="lazy" width="72" height="58">` : '<span></span>'}
          <div><a class="t-mono" href="${it.url}">${it.product_title}</a>
          ${it.variant_title ? `<div class="t-mono" style="opacity:.7">${it.variant_title}</div>` : ''}</div>
        </div>
        <div>
          <div class="sb-qty"><button type="button" data-qty="${it.quantity - 1}" aria-label="Decrease">−</button><span class="t-mono">${it.quantity}</span><button type="button" data-qty="${it.quantity + 1}" aria-label="Increase">+</button></div>
          <button type="button" class="sb-line__remove" data-qty="0">Remove</button>
        </div>
        <div class="t-mono">${money(it.final_line_price)}</div>
      </div>`).join('');
    foot.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
    const threshold = (cfg.freeShipping || 0) * 100;
    const shipText = foot.querySelector('[data-ship-text]');
    const shipBar = foot.querySelector('[data-ship-bar]');
    if (threshold) {
      const left = threshold - cart.total_price;
      const leftAmt = left / 100;
      shipText.textContent = left > 0 ? `Spend $${leftAmt % 1 === 0 ? leftAmt.toFixed(0) : leftAmt.toFixed(2)} more to get free shipping!` : 'You’ve unlocked free shipping!';
      shipBar.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    }
  }

  async function changeLine(line, quantity) {
    const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
    renderCart(await r.json());
  }

  function openCart() { body.classList.add('cart-open'); drawer && drawer.querySelector('[data-cart-close]')?.focus(); }
  function closeCart() { body.classList.remove('cart-open'); }

  document.querySelectorAll('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); getCart().then(renderCart); openCart(); }));
  document.querySelectorAll('[data-cart-close]').forEach((b) => b.addEventListener('click', closeCart));
  document.querySelector('.sb-overlay')?.addEventListener('click', () => { closeCart(); closePopup(); });
  drawer?.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]'); if (!b) return;
    changeLine(+b.closest('[data-line]').dataset.line, Math.max(0, +b.dataset.qty));
  });

  document.querySelectorAll('form[data-product-form]').forEach((form) =>
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type=submit]'); const msg = form.querySelector('[data-form-msg]');
      btn.disabled = true; if (msg) msg.textContent = '';
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const data = await r.json();
        if (!r.ok) throw new Error(data.description || 'Could not add to cart');
        renderCart(await getCart()); openCart();
      } catch (err) { if (msg) msg.textContent = err.message; }
      finally { btn.disabled = false; }
    })
  );

  /* ---------- Related products (Shopify recommendations) ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(async (el) => {
    try {
      const r = await fetch(el.dataset.url);
      const html = await r.text();
      const tmp = document.createElement('div'); tmp.innerHTML = html;
      const inner = tmp.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    } catch (_) {}
  });

  /* ---------- Newsletter pop-up: shows once, remembers dismissal ---------- */
  const popup = document.querySelector('[data-popup]');
  const KEY = 'sb_popup_dismissed';
  function remember() { try { localStorage.setItem(KEY, String(Date.now())); } catch (_) {} }
  function dismissed() { try { const t = +localStorage.getItem(KEY); return t && Date.now() - t < 1000 * 60 * 60 * 24 * 30; } catch (_) { return false; } }
  function closePopup() { if (body.classList.contains('popup-open')) { body.classList.remove('popup-open'); remember(); } }
  if (popup) {
    popup.querySelectorAll('[data-popup-close]').forEach((b) => b.addEventListener('click', closePopup));
    popup.querySelector('form')?.addEventListener('submit', remember);
    const posted = /customer_posted=true/.test(location.search);
    if (posted) remember();
    if (!dismissed() && !posted && !window.Shopify?.designMode) {
      setTimeout(() => body.classList.add('popup-open'), (+popup.dataset.delay || 8) * 1000);
    }
  }

  getCart().then(renderCart).catch(() => {});
})();
